module.exports = __webpack_public_path__ + "static/BannerHD-ea5efc8e054724a7e237cd547f8988f5.png";